import { createSelector } from 'reselect';
import { createErrorDataSelector } from 'selectors/selectorUtils';

const getChartData = ({ chartView }) => {
    return chartView?.chartData;
};

const getSelectedKpi = ({ crossAssetAnalysisSidepanel }) => {
    return crossAssetAnalysisSidepanel?.selectedKpi?.kpi;
};

const getAsset = ({ crossAssetAnalysisSidepanel }) => {
    return crossAssetAnalysisSidepanel?.selectedKpi?.asset;
};
const getChartLoadingStatus = ({ chartView }) => {
    return chartView?.chartStatus?.loadingStatus;
};

const getChartStatusError = ({ chartView }) => {
    return {
        loadingStatus: chartView?.chartStatus?.loadingStatus,
        error: chartView?.chartStatus?.error
    };
};

const getChartErrorData = createErrorDataSelector(getChartStatusError);

const getSelectedKPIType = ({ chartView }) => {
    return chartView?.selectedKPIType;
};

const getDateSelection = ({ overview }) => {
    return overview?.dateSelection;
};

const getIsZoomed = ({ chartView }) => {
    return chartView?.trendChartZoom?.isZoomed;
};

const getActiveTab = ({ chartView }) => {
    return chartView?.activeTab;
};


export const getModel = createSelector([
    getSelectedKpi,
    getChartData,
    getAsset,
    getChartLoadingStatus,
    getChartErrorData,
    getSelectedKPIType,
    getDateSelection,
    getIsZoomed,
    getActiveTab
],
    (
        selectedKpi,
        chartData,
        asset,
        chartLoadingStatus,
        chartErrorData,
        selectedKPIType,
        dateSelection,
        isZoomed,
        activeTab
    ) => {
        return {
            selectedKpi,
            chartData,
            asset,
            chartLoadingStatus,
            chartErrorData,
            selectedKPIType,
            dateSelection,
            isZoomed,
            activeTab
        };
    });
